// extracted by mini-css-extract-plugin
export default {"styledPage":"Typography_styledPage__Y-2hq"};